import { render, staticRenderFns } from "./getFinancialAmount.vue?vue&type=template&id=695dfa20&scoped=true&"
import script from "./getFinancialAmount.vue?vue&type=script&lang=js&"
export * from "./getFinancialAmount.vue?vue&type=script&lang=js&"
import style0 from "./getFinancialAmount.vue?vue&type=style&index=0&id=695dfa20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695dfa20",
  null
  
)

export default component.exports